<template>
  <section class="event-create-page">
    <AppPageTitleBar
      :title="pageTitle"
      :back-to="{ name: 'events-list' }"
      back-label="Natrag"
    />

    <EventForm
      form-id="event-create-form"
      submit-text="Kreiraj događaj"
      :is-saving-event="isSavingEvent"
      @submit="saveNewEventAsync"
    />
  </section>
</template>

<script setup>
import { computed, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import AppPageTitleBar from '../../components/AppPageTitleBar.vue'
import EventForm from '../../components/EventForm.vue'
import { apiClient } from '../../services/apiClient'
import { showRequestErrorToast, showSuccessToast } from '../../store/appStore'

const route = useRoute()
const router = useRouter()

const pageTitle = computed(() => route.meta.title)
const isSavingEvent = ref(false)

async function saveNewEventAsync (eventFormValues) {
  if (isSavingEvent.value) {
    return
  }

  isSavingEvent.value = true

  try {
    const createdEvent = await apiClient.postAsync('/api/events', eventFormValues)

    showSuccessToast('Događaj je uspješno kreiran.')

    await router.push({
      name: 'event-detail',
      params: {
        eventId: createdEvent.id,
      },
    })
  } catch (error) {
    console.error('Failed to create event.', error)
    showRequestErrorToast(error, 'Događaj nije bilo moguće kreirati.')
  } finally {
    isSavingEvent.value = false
  }
}
</script>
